import { RoleModel } from '../api.service';

export const roleMockData: RoleModel[] = [
  new RoleModel({
    id: 1,
    name: 'Administrator',
    description: 'Administrator'
  }),
  new RoleModel({
    id: 2,
    name: 'UserManagement',
    description: 'UserManagement'
  })
];
